import { SimpleQueryParam, ObjectQueryParam } from '../../models'

const ONLY_DASHED_WORDS = /^[\w\-\_]+$/
const QUERY_STRING_OBJECT_FORMAT = /^([\w\-\_]+)\[([\w\-\_]+)\]$/

export class QueryParamFactory {
  private _creationStrategyMap = [
    {
      condition: (queryString: string) => !!queryString.match(ONLY_DASHED_WORDS),
      create: (key, value) =>  new SimpleQueryParam(key, value)
    },
    {
      condition: (queryString: string) => !!queryString.match(QUERY_STRING_OBJECT_FORMAT),
      create: (key, value) =>  {
        const keys = key.match(QUERY_STRING_OBJECT_FORMAT)
        const valueObject = {}
        valueObject[keys[2]] = value
        return new ObjectQueryParam(keys[1], valueObject)
      }
    }
  ]

  public create(pair: string) {
    const [key, value] = decodeURI(pair).split('=')
    const strategy = this._creationStrategyMap.find((strtgy) => {
      return strtgy.condition(key)
    })

    if (!strategy) { throw Error(`No query param stategy defined for '${key}'`) }

    return strategy.create(key, value)
  }

  public createNull() {
    return new SimpleQueryParam('', '')
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/factories/query-param/query-param.factory.ts